module.exports = __webpack_public_path__ + "static/media/sgd-5.981a4a0b.png";